<script>
    import { getContext } from 'svelte';
    import { publishOpenAction } from './openable';
    import FormatHelper from '../scripts/FormatHelper';
    import CopyButton from '../CopyButton.svelte';

    export let playgroundHandled;
    export let playground;
    $: playgroundTitle = getTitle(playground);

    // Lets the sidebar open the item from the keyboard
    $: publishOpenAction(playground, action);

    let getMap = getContext('getMap');

    function getTitle(playground) {
        if (!playground) {
            return '';
        }

        if (playground.name && playground.municipality) {
            return `Ny lekplats: ${playground.name} (${playground.municipality})`;
        }

        if (playground.name) {
            return 'Ny lekplats: ' + playground.name;
        }

        if (playground.municipality) {
            return `Ny lekplats i ${playground.municipality}`;
        }

        return 'Ny lekplats';
    }

    function playgroundClosed() {
        if (!playground || !playgroundHandled) {
            return;
        }

        // Make sure the playground was indeed handled
        if (playground.state == 'draft') {
            return;
        }

        // Let the sidebar know that this item should be removed
        playgroundHandled(playground);
    }

    function action() {
        getMap().openApprovePopup(playground, playgroundClosed);
    }

</script>

<p>
    <!-- svelte-ignore a11y-missing-attribute -->
    <a on:click|preventDefault={action}>{playgroundTitle}</a>
</p>
<p class="small-line">
    {FormatHelper.dateTime(playground.created)}
</p>
<p class="small-line">
    <i class="fas fa-map-marker" />
    {playground._id}
    <CopyButton text={playground._id} />
</p>
{#if playground.user}
    <p class="small-line">
        <i class="fas fa-user" />
        {playground.user}
        <CopyButton text={playground.user} />
    </p>
{/if}

<style>
    a {
        cursor: pointer;
    }

    p {
        margin: 0;
        padding: 0;
    }

    p.small-line {
        font-size: 12px;
    }
</style>
